const textProps = {
  title: "Sign In",
  subtitle: "Or sign in with credentials",
  button: {
    fullWidth: true,
    color: "dark",
    children: "Sign in",
  },
  forgotPassword: {
    href: "#/forgot-password",
  },
  createAccount: {
    href: "#/register",
  },
  checkbox: {
    label: "Remember me",
  },
  inputs: [
    {
      label: "Email",
      input: {
        type: "email",
        placeholder: "Email",
      },
    },
    {
      label: "Password",
      input: {
        type: "password",
        placeholder: "Password",
      },
    },
  ],
};
export default textProps;
